module.exports = __webpack_public_path__ + "static/media/I_forgot_guy.ae65c29d.jpg";